/**
 * Rapor tablolarında Ctrl+Alt+G ile gösterilen ek alanlar.
 * Sadece default tabloda OLMAYAN alanlar (çakışma olmasın diye).
 * Var olan kolonların sonuna eklenir.
 */
export function getExtraReportColumns() {
  return [
    { field: 'osName', headerName: 'İşletim Sistemi', minWidth: 120, headerAlign: 'center', align: 'center', flex: 1 },
    // { field: 'osVersion', headerName: 'OS Versiyon', minWidth: 110, headerAlign: 'center', align: 'center', flex: 1 },
    { field: 'publicIp', headerName: 'Public IP', minWidth: 130, headerAlign: 'center', align: 'center', flex: 1 },
    // { field: 'ramGb', headerName: 'RAM (GB)', minWidth: 90, headerAlign: 'center', align: 'center', flex: 1 },
    // {
    //   field: 'screenResolution',
    //   headerName: 'Çözünürlük',
    //   minWidth: 140,
    //   headerAlign: 'center',
    //   align: 'center',
    //   flex: 1,
    //   valueGetter: (params) => {
    //     const sr = params.row.screenResolution
    //     if (!sr) return '-'
    //     if (typeof sr === 'object' && sr.width != null && sr.height != null) return `${sr.width}×${sr.height}`
    //     return String(sr)
    //   },
    // },
    // { field: 'timestamp', headerName: 'Timestamp', minWidth: 200, headerAlign: 'center', align: 'center', flex: 1 },
    // { field: 'timezone', headerName: 'Saat Dilimi', minWidth: 150, headerAlign: 'center', align: 'center', flex: 1 },
    // { field: 'topicDetail', headerName: 'Konu Detay', minWidth: 180, headerAlign: 'center', align: 'center', flex: 1 },
    {
      field: 'userAgent',
      headerName: 'User-Agent',
      minWidth: 280,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      valueGetter: (params) => (params.row.userAgent && typeof params.row.userAgent === 'string' ? params.row.userAgent : '-'),
    },
    { field: 'localIp', headerName: 'Yerel IP', minWidth: 130, headerAlign: 'center', align: 'center', flex: 1 },
  ]
}
